// extracted by mini-css-extract-plugin
export default {"container":"remark_card_container__KCyUv","corner_button":"remark_card_corner_button__Vwo5l"};